import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useConversationStats = () => {
  const [stats, setStats] = useState({
    active: 0,
    waiting: 0,
    agentsOnline: 0,
    todayTotal: 0
  });

  useEffect(() => {
    const fetchStats = async () => {
      // Count active conversations
      const { count: activeCount } = await supabase
        .from('conversations')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'active');

      // Count waiting conversations
      const { count: waitingCount } = await supabase
        .from('conversations')
        .select('*', { count: 'exact', head: true })
        .eq('status', 'waiting');

      // Count online agents
      const { count: onlineAgents } = await supabase
        .from('agent_availability')
        .select('*', { count: 'exact', head: true })
        .eq('is_online', true);

      // Count today's conversations
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const { count: todayCount } = await supabase
        .from('conversations')
        .select('*', { count: 'exact', head: true })
        .gte('created_at', today.toISOString());

      setStats({
        active: activeCount || 0,
        waiting: waitingCount || 0,
        agentsOnline: onlineAgents || 0,
        todayTotal: todayCount || 0
      });
    };

    fetchStats();

    // Refresh stats every 30 seconds
    const interval = setInterval(fetchStats, 30000);

    return () => clearInterval(interval);
  }, []);

  return stats;
};
